import { AnyAction } from 'redux';
import { SET_DOWNGRADE_STATE, CLEAR_DOWNGRADE_STATE } from 'stash/actions';
import { DowngradeState } from 'stash/actions/downgrade';

const downgradeReducer = (
	state: DowngradeState | null = null,
	action: AnyAction
): DowngradeState | null => {
	switch (action.type) {
		case SET_DOWNGRADE_STATE:
			return {
				...state,
				...action.payload,
			};
		case CLEAR_DOWNGRADE_STATE:
			return null;
		default:
			return state;
	}
};

export default downgradeReducer;
